import api from "./http";

export async function authorize({ login, password }) {
    const response = await api.post("/login", {login: login, password: password});
    return response.data;
};

export async function authorizeTelegram(initData) {
    const response = await api.post("/telegram/login", {init_data: initData});
    return response.data;
};